<template>
  <div class="travel-insurance">
    <prompt-dialogs 
      v-model="showDialog" 
      @agree="handleAgree"
      @open-agreement="handleOpenAgreement"
    />
    <!-- 协议查看弹窗 -->
    <agreement-viewer
      v-model="showAgreementViewer"
      :agreement="currentAgreement"
      :is-in-sequence="false"
      :current-index="0"
      :total-count="1"
    />
    <div class="hero">
      <div class="hero-whole">
        <div class="hero-content">
          <div class="hero-title">
            <div class="hero-title-text">平安行 <span>.</span> 境内旅游险(互联网)</div>
            <!-- <span class="hero-title-sub">互联网产品</span> -->
          </div>
          <div class="hero-desc">
            <span>30万</span>意外保额 | 任游神州，玩美中国
          </div>
          <div class="hero-price">
            起底价格 <span class="hero-price-unit">￥</span><span class="hero-price-num">0.70</span>/人起
          </div>
          <div class="hero-btn" @click="handleInsure">
            立即投保
          </div>
        </div>
        <div class="hero-img">
          <img src="/images/lvyouxian/hero1.png" alt="">
        </div>
      </div>
      <div class="hero-content_btm">
        <div class="hero_bottom">
          <div class="hero_btm_left">
            <div class="btm_left_img">
              <img src="/images/lvyouxian/hero3.png" alt="">
            </div>
            <div class="btm_left_con">
              <div class="btm_left_title">畅玩境内，神州大地任我行</div>
              <div class="btm_left_tips">温馨提示：本产品承保区域不含港澳台地区</div>
            </div>
          </div>
          <div class="hero_btm_right">
            <div class="btm_right_img">
              <img src="/images/lvyouxian/hero2.png" alt="">
            </div>
            <div class="btm_right_con">
              <div class="btm_right_title">“因旅游、短期工作、短期留学、探亲等必须离开其经常居住地等行为”</div>
              <div class="btm_right_tips">——旅行定义</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="risk_coverage">
      <div class="risk_content">
        <img src="/images/lvyouxian/lvyou2.png" alt="">
      </div>
    </div>
    <div class="cost_performance">
      <div class="cost_content">
        <img src="/images/lvyouxian/lvyou3.png" alt="">
      </div>
    </div>
    <div class="plan">
      <div class="plan_content" @click="handleInsure">
        <img src="/images/lvyouxian/lvyou4.png" alt="">
      </div>
    </div>
    <div class="claim_settlement">
      <div class="claim_content">
        <img src="/images/lvyouxian/lvyou5.png" alt="">
      </div>
    </div>
    <div class="insure">
      <div class="insure_title">准备好开启您的下一段精彩旅程了吗？</div>
      <div class="insure_tips">仅需0.7元起，即可获得全方位的旅行安全守护</div>
      <div class="insure_btn" @click="handleInsure">立即投保</div>
    </div>
  </div>
</template>

<script>
import PromptDialogs from './lyComponents/promptDialogs.vue';
import AgreementViewer from './lyComponents/agreementViewer.vue';
// import { start, resetRecording, captureAsBlob, clearScreenshotUrls } from '@/utils/recordingUtils';
// import { uploadScreenshot } from '@/api';
import { getProductList } from '@/api';

export default {
  components: {
    PromptDialogs,
    AgreementViewer
  },
  props: {
    code: String
  },
  data() {                    
    return {
      showDialog: false,
      showAgreementViewer: false,
      currentAgreement: null,
      productDetail: null
    };
  },
  mounted() {
    this.loadProductList();

    // 刷新页面时直接清除所有录制数据
    // resetRecording();
    // console.log('页面加载，已清除录制数据');
  },

  methods: {
    // 加载产品列表
    async loadProductList() {
      try {
        const res = await getProductList();
        if(res && res.code == 0){
           // 如果有产品列表，选中第一个作为当前产品
          if (res.data.length > 0) {
            this.productDetail = res.data[0];
          }
        }
      } catch (error) {
        console.error('加载产品列表失败', error);
      }
    },
    handleInsure() {
      // 先打开弹窗，确保用户体验不受影响
      this.showDialog = true;
      
      // 完全重置录制状态（清空内存 + sessionStorage + 停止旧录制）
      // resetRecording();
      
      // 清除截图数据
      // clearScreenshotUrls();
      
      // 开始新录制
      // try {
      //   start({
      //     productId: this.productDetail.id || 'default',
      //     startPage: 'travelInsurance'
      //   });
      //   console.log('travelInsurance 新录制已启动');
      // } catch (error) {
      //   console.error('录制启动失败', error);
      // }
    },
    
    /**
     * 截图温馨提示弹窗并上传
     */
    // async capturePromptDialog() {
    //   try {
    //     // 找到温馨提示弹窗元素
    //     const dialog = document.querySelector('.v-dialog--active .prompt-dialog') ||
    //                     document.querySelector('.prompt-dialog-content') ||
    //                     document.querySelector('.v-dialog--active');
    //     if (!dialog) {
    //       console.warn('未找到温馨提示弹窗元素');
    //       return null;
    //     }
    //     
    //     const { blob } = await captureAsBlob(dialog);
    //     const fileName = `screenshot_prompt_dialog_${Date.now()}.jpg`;
    //     const res = await uploadScreenshot(blob, fileName);
    //     
    //     if (res && res.code == 0 && res.data) {
    //       console.log('温馨提示弹窗截图上传成功:', res.data);
    //       return res.data;
    //     }
    //     console.warn('温馨提示弹窗截图上传返回异常:', res);
    //     return null;
    //   } catch (error) {
    //     console.error('温馨提示弹窗截图失败:', error);
    //     return null;
    //   }
    // },
    async handleAgree() {
      // 点击"我已逐页阅读上述内容并同意"时截图温馨提示弹窗
      // const screenshotUrl = await this.capturePromptDialog();
      // 如果有截图链接，保存到 sessionStorage 传递给 planSelection
      // if (screenshotUrl) {
      //   sessionStorage.setItem('prompt_screenshot', JSON.stringify([screenshotUrl]));
      // }
      // 用户同意后继续投保流程
      this.showDialog = false;
      this.$router.push({
        name: 'plan-selection',
        query: {
          code: this.productDetail.id
        }
      });
    },
    // 处理打开协议
    handleOpenAgreement(agreement) {
      this.currentAgreement = agreement;
      this.showAgreementViewer = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.travel-insurance {
  width: 100%;
}

.hero {
  position: relative;
  background-color: #F4F5FB;
  .hero-whole {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    .hero-content {
      padding-top: 47px;
      .hero-title {
        padding-right: 80px;
        .hero-title-text{
          display: inline-block;
          padding-right: 15px;
          font-size: 34px;
          font-weight: 500;
          color: #000;
          span {
           line-height: 1;
           vertical-align: text-top; 
          }
        }
        .hero-title-sub {
          padding: 0 5px;
          background-color: #FBE7E9;
          color: #DD122A;
          font-size: 14px;
          vertical-align: top;
        }
        
      }
      .hero-desc {
        padding-top: 10px;
        color: #333;
        font-size: 16px;
        span {
          color: #DD122A;
        }
      }
      .hero-price {
        padding-top: 60px;
        padding-bottom: 25px;
        color: #333;
        font-size: 12px;
        .hero-price-unit {
          font-size: 14px;
          color: #DD122A;
          font-weight: 500;
        }
        .hero-price-num {
          color: #DD122A;
          font-size: 24px;
          font-weight: 500;
        }
      }
      .hero-btn {
        width: 140px;
        height: 40px;
        background-color: #DD122A;
        cursor: pointer;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
      }
    }
    .hero-img {
      width: 607px;
      height: 432px;
      img {
        height: 100%;
      }
    }
  }
  .hero-content_btm {
    position: absolute;
    bottom: 0;
    left: 0;
    right:0 ;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    background-color: rgba(251, 252, 253, 0.81);
    .hero_bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1097px;
      height: 88px;
      
      .hero_btm_left, .hero_btm_right {
        display: flex;
        .btm_left_img, .btm_right_img {
          width: 34px;
          img {
            width: 100%;
          }
        }
        .btm_left_con, .btm_right_con {
          padding-left: 25px;
          .btm_left_title {
            color: #333;
            font-size: 18px;
            font-weight: 500px;
          }
          .btm_right_title {
            color: #333;
            font-size: 14px;
            font-weight: 500px;
          }
          .btm_left_tips {
            color: #DD122A;
            font-size: 12px;
          }
          .btm_right_tips {
            color: #000;
            text-align: right;
            font-size: 14px;
          }
        }

      }
    }
  }
}
.risk_coverage {
  height: 485px;
  background-color: #fff;
  .risk_content {
    padding-top: 48px;
    width: 1200px;
    height: 385px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.cost_performance {
  height: 692px;
  background-color: #F8FAFC;
  .cost_content {
    padding-top: 50px;
    width: 1200px;
    height: 571px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.plan {
  height: 685px;
  background-color: #FFFFFF;
  .plan_content {
    padding-top: 48px;
    width: 1200px;
    height: 560px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.claim_settlement {
  height: 613px;
  background-color: #F8FAFC;
  .claim_content {
    padding-top: 48px;
    width: 1200px;
    height: 457px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.insure {
  padding: 46px 0;
  height: 259px;
  background-color: #DD122A;
  .insure_title {
    text-align: center;
    color: #FFFFFF;
    font-size: 28px;
    font-weight: 500;
  }
  .insure_tips {
    padding: 10px 0 35px;
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
  }
  .insure_btn {
    width: 154px;
    height: 48px;
    background-color: #fff;
    margin: 0 auto;
    cursor: pointer;
    border-radius: 8px;
    color: #DD122A;
    font-size: 20px;
    font-weight: 500;
    line-height: 48px;
    text-align: center;
  }
}

</style>






